// `SITE-SPD02`: the styles editor HTML needs travel with the component that renders it, so a
// route carries them only when it renders rich content (they used to block every page from the
// root layout). Every `.progsity-content` element and every KaTeX formula the site prints comes
// from here, `QuizRichText`, the announcement bodies or the editor, and each imports them.
import '@/styles/progsity-content.css'
import 'katex/dist/katex.min.css'
import { MermaidRenderer } from '@/components/mermaid-renderer'
import { renderMathNodes } from '@/lib/render-math'
import { sanitizeHtml } from '@/lib/sanitize-html'
import { cn } from '@/lib/utils'

interface RichContentProps {
  html: string
  className?: string
}

export function RichContent({ html, className }: RichContentProps) {
  if (!html) return null
  const clean = renderMathNodes(sanitizeHtml(html))
  return (
    <>
      <div className={cn('progsity-content', className)} dangerouslySetInnerHTML={{ __html: clean }} />
      {/* A diagram is stored as its Mermaid source. Lessons drew it; every other page (a problem,
          an editorial, a contest) showed the source until this. Mermaid loads only when needed. */}
      {clean.includes('data-type="diagram"') && <MermaidRenderer />}
    </>
  )
}
